<template>
  <div style="height: 100vh">
    <CRow class="h-100" alignHorizontal="center" alignVertical="center">
      <CCol class="text-center">
        <LoadingSpinner />
        <div class="h5 mt-5 text-primary" style="display: inline-block">
          {{ this.$t('general.waitingConfiguration.text') }}
        </div>
        <div class="h5 text-primary text-left pl-1" style="display: inline-block; width: 50px">{{ dots }}</div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import services from '@/services.js'

export default {
  components: {
    LoadingSpinner,
  },
  data() {
    return {
      dots: '.',
      interval: null,
      teste: 0,
    }
  },
  mounted() {
    let session = this.$store.state.auth.session
    if (session.organization.organizationStatus !== 4) {
      this.$router.push({ name: 'home' })
      return
    }

    this.checkSessionStatus()
    this.dotsVariation()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    dotsVariation() {
      this.interval = setInterval(() => {
        this.dots = this.dots.length < 4 ? this.dots + ' .' : '.'
      }, 500)
    },
    handleQueries(query) {
      let queries = {}
      Object.assign(queries, query)
      delete queries.next
      return queries
    },
    checkSessionStatus() {
      let organizationId = this.$route.params.organizationId
      services.getSession(organizationId).then((res) => {
        if (res.data.data.organization.organizationStatus !== 4) {
          this.$router.push({ name: 'home', query: this.handleQueries(this.$route.query) })
        } else {
          this.teste++
          setTimeout(() => {
            this.checkSessionStatus()
          }, 5000)
        }
      })
    },
  },
}
</script>
